import { useProductTranslations } from "../../hooks/TranslationHooks";
import FormattedPrice from "../FormattedPrice";
import {
  productIsPerSquareMeter,
  productPriceUnit
} from "../../utils/ProductUtils";
import { divide } from "../../utils/NumberUtils";
import "./style.scss";
import { addVat } from "../../utils/VatUtils";
import useShowPricesWithVat from "../../hooks/useShowPricesWithVat";

const PriceArea = ({ product }) => {
  const tp = useProductTranslations();
  const showPricesWithVat = useShowPricesWithVat();
  const { unitQuantityFactor = 0 } = product;
  const isPerSquareMeter = productIsPerSquareMeter(unitQuantityFactor);
  const priceUnit = productPriceUnit(unitQuantityFactor);
  const {
    basePrice,
    unitPrice: unitBasePrice,
    previousBasePrice,
    currency
  } = product.price || {};
  const hasPrice = !!basePrice;
  const productBasePrice = basePrice ? (
    <FormattedPrice
      price={showPricesWithVat ? addVat(basePrice) : basePrice}
      sales_unit={priceUnit}
      currency={currency}
      price_class_name={!isPerSquareMeter ? "big-price" : null}
    />
  ) : null;
  const productUnitPrice =
    unitBasePrice && isPerSquareMeter ? (
      <FormattedPrice
        price={showPricesWithVat ? addVat(unitBasePrice) : unitBasePrice}
        price_class_name={"big-price"}
        price_unit={priceUnit}
        currency={currency}
      />
    ) : null;
  const previousUnitPrice =
    previousBasePrice > 0 && isPerSquareMeter ? (
      <FormattedPrice
        price={
          showPricesWithVat
            ? addVat(divide(previousBasePrice, unitQuantityFactor))
            : divide(previousBasePrice, unitQuantityFactor)
        }
        price_unit={priceUnit}
        currency={currency}
      />
    ) : null;

  return (
    hasPrice && (
      <div className={"prices"}>
        {productUnitPrice && (
          <div className={"unit-price"}>
            {productUnitPrice}
            {previousUnitPrice && (
              <div className={"previous-unit-price"}>
                {tp("previous_unit_price")}
                {previousUnitPrice}
              </div>
            )}
          </div>
        )}
        <div className={"price"}>{productBasePrice}</div>
        <div className={"price-info"}>
          ({showPricesWithVat ? tp("price_incl_vat") : tp("price_excl_vat")})
        </div>
      </div>
    )
  );
};

export default PriceArea;
